import { RootState } from "@/store";

/** Per-dataset input row counts probed from the `/stats` endpoint. */
export const selectInputRowCounts = (state: RootState) =>
  state.spatial.inputRowCounts ?? {};
